import XLSX from 'xlsx';


export default class Xlsx {

    _workBook = null

    constructor(wb) {
        this._workBook = wb;
    }

    get workBook(){
        return this._workBook;
    }

    setNewWorkbook(){
        return XLSX.utils.book_new();
    }

    appendSheet(wb, ws, wsName){
        return XLSX.utils.book_append_sheet(wb, ws, wsName);
    }


    getWorkBook(file){
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workBook = XLSX.read(data, {type: 'array', cellDates: true, dateNF: 'YYYY-MM-DD'});
                this._workBook = workBook;
                resolve(workBook);
            };

            reader.onerror = (e) => {
                reject(null);
            }

            reader.readAsArrayBuffer(file);
        });
    }

    sheetToJson(ws, start){
        const end = ws['!ref']?.split(':')[1];
        return start ? XLSX.utils.sheet_to_json(ws, {range: `${start}:${end}`, raw: false}) : XLSX.utils.sheet_to_json(ws, {raw: false});
    }

    jsonToSheet(data, header){
        return XLSX.utils.json_to_sheet(data, {header: header, dateNF: 'YYYY-MM-DD'})
    }

    aoaToSheet(data, start){
        return XLSX.utils.aoa_to_sheet(data, { origin: start , dateNF: 'YYYY-MM-DD'})
    }

    /**
     * @param ws
     * @param range : sheet범위
     * @returns 이중 array [[row],[row] ... ]
     */
    withinTheRangeSheetToJson(ws, range){
        return XLSX.utils.sheet_to_json(ws, {range: range, header: 1, dateNF: 'YYYY-MM-DD', raw: false});
    }

    writeFile(wb, fileName){
        XLSX.writeFile(wb, fileName);
    }

}